import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { APP_HYDRATED } from 'components/Pagelayout/actions';
import { queries } from './mediaQuery';
import { setMqCookie } from './actions';

export const mediaMiddleware = (): Middleware => (_: MiddlewareAPI) => {
  const isAppHydratedAction = (action: AnyAction): boolean => action.type === APP_HYDRATED;
  return (next: Dispatch) => (action: AnyAction) => {
    if (isAppHydratedAction(action)) {
      const action = Object.entries(queries).find(([query]) => matchMedia(query).matches)?.[1];
      if (action) {
        setMqCookie(action.breakpoint);
        next(action);
      }
    }
    next(action);
  };
};
